var _defs, _circle, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _path, _circle2, _line9, _line10, _line11, _line12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#efcc00;}.cls-2,.cls-5,.cls-6{fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}.cls-2{stroke:#efcc00;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{stroke:#a5a9aa;}.cls-6{stroke:#b9c1c6;}"), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(-1, 0, 0, 1, -970.2, 0)",
    gradientUnits: "userSpaceOnUse",
    id: "linear-gradient",
    x1: -989.28,
    x2: -1010.37,
    y1: 52.39,
    y2: 25.08
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfcfcf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0, -1, -1, 0, -44.28, -1021.58)",
    gradientUnits: "userSpaceOnUse",
    id: "linear-gradient-2",
    x1: -1062.77,
    x2: -1051.15,
    y1: -96.39,
    y2: -78.75
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 39.8,
    cy: 22,
    r: 12.59
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 39.8,
    x2: 39.8,
    y1: 2,
    y2: 6.44
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 39.8,
    x2: 39.8,
    y1: 37.56,
    y2: 42
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 19.8,
    x2: 24.25,
    y1: 22,
    y2: 22
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 55.36,
    x2: 59.8,
    y1: 22,
    y2: 22
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 25.66,
    x2: 28.8,
    y1: 7.86,
    y2: 11
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 50.8,
    x2: 53.94,
    y1: 33,
    y2: 36.14
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 25.66,
    x2: 28.8,
    y1: 36.14,
    y2: 33
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 50.8,
    x2: 53.94,
    y1: 11,
    y2: 7.86
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.5,15.9A17.49,17.49,0,0,1,39,25.22a13.75,13.75,0,1,1,6.92,25.62L23.5,50.9a17.5,17.5,0,0,1,0-35Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 45.89,
    cy: 37.09,
    r: 13.75,
    transform: "translate(-2.18 71.3) rotate(-74.39)"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 37.84,
    x2: 48.06,
    y1: 54.5,
    y2: 54.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 15.94,
    x2: 32.74,
    y1: 54.5,
    y2: 54.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 33.23,
    x2: 44.55,
    y1: 59.5,
    y2: 59.5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 19.96,
    x2: 27.65,
    y1: 59.5,
    y2: 59.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.666192e3d76bc591c335f6e6bc2c001f.svg";
export { ForwardRef as ReactComponent };